import { translate } from '../../../common/helpers/translate.helper';

interface GetRfqCancelActionLabelProps {
    hasQuotedOffers: boolean;
    isMultipleOffersEnabled: boolean;
    offerCount: number;
}

export const getRfqCancelActionLabel = ({
    hasQuotedOffers,
    isMultipleOffersEnabled,
    offerCount,
}: GetRfqCancelActionLabelProps): string => {
    if (!hasQuotedOffers) {
        return translate('offer.detail.header.actions.decline');
    }

    if (!isMultipleOffersEnabled || offerCount <= 1) {
        return translate('actions.cancel');
    }

    return translate('rfq.detail.cancelPopup.cancelAllOffers.button');
};
